module.exports = __webpack_public_path__ + "static/media/17_8.61a92517.png";